import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls to the top of the page whenever the route changes.
 * Excludes hash navigation (in-page anchors).
 * Drop me directly inside <BrowserRouter>.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return; // let the browser handle anchor jumps
    // Wait one frame so the new route has mounted before we scroll
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, behavior: 'auto' });
    });
  }, [pathname, hash]);
  return null;
};

export default ScrollToTop;
